module.exports = __webpack_public_path__ + "img/objBarcode.7b4ea542.svg";